import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

interface CheckoutParams {
  productId: string;
  plan: "pro" | "team";
  billingCycle: "monthly" | "yearly";
  seats?: number;
}

export const usePolarCheckout = () => {
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const startCheckout = async (params: CheckoutParams) => {
    setLoading(true);
    try {
      const { data: sessionData } = await supabase.auth.getSession();
      if (!sessionData.session) {
        toast({
          title: "Sign in required",
          description: "Please sign in to subscribe.",
          variant: "destructive",
        });
        setLoading(false);
        return;
      }

      const response = await supabase.functions.invoke("polar-checkout", {
        body: params,
      });

      if (response.error) {
        throw new Error(response.error.message || "Checkout failed");
      }

      const { url } = response.data;
      if (url) {
        window.location.href = url;
      } else {
        throw new Error("No checkout URL returned");
      }
    } catch (error: unknown) {
      console.error("Checkout error:", error);
      toast({
        title: "Checkout failed",
        description:
          error instanceof Error ? error.message : "Please try again.",
        variant: "destructive",
      });
      setLoading(false);
    }
  };

  return { startCheckout, loading };
};
